const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api";

export const OfsLogsCommand: any = {
    GetOfsInformation: Backofficebff + '/v1/postcheckoutorderfullfillment/getofsinformation',
    UpdateOfsInformation: Backofficebff + '/v1/postcheckoutorderfullfillment/updateofsinformation',
    GetHolidayDatesForCountry: Backofficebff + '/v1/postcheckoutorderfullfillment/getholidaydatesforcountry',
    SetHolidayDatesForCountries: Backofficebff + '/v1/postcheckoutorderfullfillment/setholidaydatesforcountries',
};
